export const reactReduxFirebaseConfig = {
  // userProfile: 'users',
  useFirestoreForProfile: true,
  enableLogging: 'false',
};
